import { amplitudeEventsConfig } from './index';

export type SERPOpenSource =
  (typeof amplitudeEventsConfig.SERP_OPEN_SOURCE)[keyof typeof amplitudeEventsConfig.SERP_OPEN_SOURCE];

export type DetailsPageOpenSource =
  (typeof amplitudeEventsConfig.DETAILS_PAGE_OPEN_SOURCE)[keyof typeof amplitudeEventsConfig.DETAILS_PAGE_OPEN_SOURCE];
